import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default function SwiperStyle3(props) {
    const { listsImag=[], viewFunc, is830=false } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [swiper, setswiper] = useState({});
    const [index, setindex] = useState(0);


    return (
        <div className='big_swiper_img_container'>
            <div className='big_swiper_img_box'>
                {(!is830 && listsImag?.length > 1) &&
                    <>
                        <button onClick={() => swiper.slidePrev()} className='slidenavigateButton02'>
                            <img src="./images/icons/chevron-left.svg" width='56' />
                        </button>
                        <button onClick={() => swiper.slideNext()} className='slidenavigateButton02 right'>
                            <img src="./images/icons/chevron-right02.svg" width='56' />
                        </button>
                    </>
                }

                <div className='big_swiper_content'>
                    <Swiper
                        onInit={(ev) => {
                            setswiper(ev)
                        }}
                        loop={true}
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={0}
                        slidesPerView={1}
                        onSlideChange={(res) => {
                            setindex(res?.realIndex);
                        }}
                        onSwiper={(swiper) => {
                            // console.log(swiper);
                        }}
                        style={{
                        }}
                    >
                        {listsImag?.length > 0 && listsImag?.map((x, i) => {
                            return (
                                <SwiperSlide key={i} className="block_img_cover" onClick={() => {
                                    if(viewFunc) viewFunc();
                                }}>
                                    <div className='big_swiper_img_div'>
                                        {!is830 ? 
                                            <TransformWrapper initialScale={1} minScale={1} maxScale={5}>
                                                <TransformComponent>
                                                    <img src={x} 
                                                        className='big_swiper_img'
                                                    />
                                                </TransformComponent>
                                            </TransformWrapper>
                                            :
                                            <img src={x} 
                                                className='big_swiper_img'
                                            />
                                        }
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

                <div className="swiper_page_number02">
                    <div className="swiper_page_number_pagebox">
                        <p className='page_num'>{index + 1}</p>
                        <p className='total_num'>/{listsImag?.length}</p>
                    </div>
                </div>
            </div>

        </div>
    )    
}